import { apiClient } from './client';

// docs/work_log/v1031-remaining-work-batch-12 §3 — Retire 후보 조회 API.
// ADMIN 만 접근 가능. backend 의 RobotRetireScanCron.scan() 결과 그대로.

export interface RetireCandidate {
  id: string;
  serialShort: string | null;
  serialLong: string | null;
  status: string;
  lastReturnedAt: string | null;
  daysSinceLastReturn: number;
}

// docs/work_log/v1033-remaining-work-batch-14 §6 — 분포 + age bucket metric.
export interface RetireScanMetrics {
  totalCandidates: number;
  byStatus: Record<string, number>;
  byAgeBucket: {
    '90-180': number;
    '180-365': number;
    '365+': number;
  };
  oldestDaysIdle: number;
}

export interface RetireCandidatesResponse {
  scanned: number;
  candidates: RetireCandidate[];
  // batch-14 §6 — admin page 의 분포 chip 표시용.
  metrics?: RetireScanMetrics;
}

export const retireCandidatesApi = {
  async list(): Promise<RetireCandidatesResponse> {
    const { data } = await apiClient.get<RetireCandidatesResponse>('/admin/retire-candidates');
    return data;
  },
};
